export default "__VITE_ASSET__3983c991__$_?nuxt_component=async&nuxt_component_name=SvgoHelp2952984__"